export const Translations = {
  'en': {
    'shippingText': 'Shipping',
    'shipToText': 'Ship To',
    'shipMethodText': 'Shipping Method',
    'monthlyText': 'monthly',
    'biMonthlyText': 'bi-monthly',
    'footerText': 'Your ADR order will be processed on the ',
    'shippingEditText': 'Edit Shipping',
    'businessDaysText': 'Business Days',
    'frequencyText': 'Frequency',
    'processDateText': 'Process Date',
    'everyOtherMonth': 'Every Other Month (Bimonthly)',
    'newAddressText': 'New Address',
    'shippingCancelText': 'cancel',
    'saveChangesText': 'save changes',
    'headerText': 'Changing your address will cause any changes you made to the shipping method to be lost. Please review your shipping method before submitting your order.',
    'phoneText': 'Phone: ',
    'frequencyChangeContentTop': 'BI-MONTHLY AGREEMENT',
    'frequencyChangeContentBottom': 'Bi-monthly orders will earn 10% in product points on each ADR order.',
    'saveFrequencyText': 'Save',
    'frequencyModalCancelText': 'Cancel',
    'frequencyCheckboxLabel': 'I would like to continue with this change',
    'pickUpText': 'Pick Up Center \nNu Skin Enterprises Singapore Pte Ltd \n8 Eu Tong Sen Street, The Central, \n#25-89 \nSingapore 059818 \n\nPhone: +65 6837 3363 \n\nOpening Hours: \nMonday to Friday: 12pm – 8:30pm \nSaturday: 12pm – 4pm',
    'selectedPickUpPointLabel': 'Pickup From',
    'shippingPickUpWarningText': 'Unpicked orders will be shipped after 7 days with an administrative charge of $10.',
    'pickUpShippingAddressLabel': 'Secondary Shipping Address',
    'shippingType': [{'key':0,'value':'My Address'}, {'key':1,'value':'Pick Up'}]
  },
  'zh': {
    'shippingText': '运输方式',
    'shipToText': '运送到',
    'shipMethodText': '运输方法',
    'monthlyText': '每月',
    'biMonthlyText': '双月',
    'footerText': '您的ADR订单处理日期：',
    'shippingEditText': '编辑送货',
    'businessDaysText': '工作日',
    'frequencyText': '频率',
    'processDateText': '处理日期',
    'everyOtherMonth': '每隔一个月（双月)',
    'newAddressText': '新地址',
    'shippingCancelText': '取消',
    'saveChangesText': '保存更改',
    'headerText': '更改您的地址将导致您对运输方式所做的任何更改都会丢失。提交订单前请检查您的送货方式。',
    'phoneText': '电话',
    'frequencyChangeContentTop': '双月协议',
    'frequencyChangeContentBottom': '双月订单将在每个ADR订单的产品点赚取10％。',
    'saveFrequencyText': '保存',
    'frequencyModalCancelText': '取消',
    'frequencyCheckboxLabel': '我想继续这个改变',
    'pickUpText': '接送中心 \nNu皮肤企业新加坡私人有限公司 \n8中环欧盟森街，\n＃25-89 \ n新加坡059818\n\n电话：+65 6837 3363 \n\n开放时间：\n周一至周五：中午12点 - 晚上8:30 \n周六：中午12点至下午4点',
    'shippingPickUpWarningText': '未经批准的订单将在7天后发货，行政费用为10美元.',
    'pickUpShippingAddressLabel': '二级送货地址',
    'shippingType': [{'key':0,'value':'我的地址'}, {'key':1,'value':'拾起'}]
  },
  'es': {
    'shippingText': 'Envío',
    'shipToText': 'Enviar a',
    'shipMethodText': 'Método de envío',
    'monthlyText': 'Mensual',
    'biMonthlyText': 'Bi-mensual',
    'footerText': 'Su pedido recurrente se procesará en ',
    'shippingEditText': 'Editar envío',
    'businessDaysText': 'Días Hábiles',
    'frequencyText': 'Frecuencia',
    'processDateText': 'Fecha de procesamiento',
    'everyOtherMonth': 'Bi-Mensual (Cada Mes de por Medio)',
    'newAddressText': 'Nueva Dirección',
    'shippingCancelText': 'Cancelar',
    'saveChangesText': 'Guardar cambios',
    'headerText': 'El cambio de dirección provocará la pérdida de los cambios realizados en el método de envío. Por favor, revise su método de envío antes de enviar su pedido.',
    'phoneText': 'Teléfono',
    'frequencyChangeContentTop': 'ACUERDO BI-MENSUAL',
    'frequencyChangeContentBottom': 'Los pedidos bimensuales ganarán 10% en puntos de productos en cada pedido de ADR.',
    'saveFrequencyText': 'Guardar',
    'frequencyModalCancelText': 'Cancelar',
    'frequencyCheckboxLabel': 'Me gustaría continuar con este cambio',
    'pickUpText': 'Centro de recogida \nN Skin Enterprises Singapore Pte Ltd \n8 Eu Tong Sen Street, The Central, \n # 25-89 \nSingapore 059818 \n\nPhone: +65 6837 3363 \n\nHorario de apertura: \nde lunes a viernes: 12 pm - 8:30 pm \n sábado: 12pm - 4pm',
    'shippingPickUpWarningText': 'Los pedidos no seleccionados se enviarán después de 7 días con un cargo administrativo de $ 10.',
    'pickUpShippingAddressLabel': 'Dirección de envío secundaria',
    'shippingType': [{'key':0,'value':'Mi dirección'}, {'key':1,'value':'Recoger'}]
  }
};
